export function formatValueForDisplay(number: number) {
  return number.toLocaleString('sv-SE').replace('.', ',')
}
